import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { UserIdentity, Permission } from '../webApi/DataModels'
import webApi from '../webApi'
import { findIndex, filter, flatMap, map } from 'lodash'
class UserState {
  public userIdentity:UserIdentity = null
}
const mutations = <MutationTree<UserState>>{
  parseUserIdentity (state: UserState) {
    state.userIdentity = <UserIdentity>JSON.parse(window.localStorage.getItem('User_Identity'))
  },
  reset (state:UserState) {
    state.userIdentity = null
  }
}
const actions = <ActionTree<UserState, any>>{
  reset (store: ActionContext<UserState, any>):void {
    store.commit('reset')
  },
  getUserIdentity (store: ActionContext<UserState, any>):Promise<any> {
    return webApi.account.get_User_Identity().then((response) => {
      window.localStorage.setItem('User_Identity', JSON.stringify(response.data))
      store.commit('parseUserIdentity')
      return Promise.resolve(response)
    }).catch((error) => {
      window.localStorage.removeItem('User_Identity')
      window.bus.$emit('openErrorModal', 'Error loading the user: ' + error)
      return Promise.reject(error)
    })
  },
  hasPermission ({ state }: {state:UserState}, { permissionType, permissionValue }: {permissionType:string, permissionValue:string}):boolean {
    var claims:Permission[] = []
    if (state.userIdentity && state.userIdentity.Claims) {
      claims = state.userIdentity.Claims
    }
    return (findIndex(claims, { Type: permissionType, Value: permissionValue }) > -1)
  },
  logout () {
    window.localStorage.removeItem('User_Identity')
  }
}
const getters = <GetterTree<UserState, any>> {
  getPermissions (state:UserState): Permission[] {
    if (!state.userIdentity || !state.userIdentity.Claims) {
      return []
    } else {
      return state.userIdentity.Claims
    }
  },
  getClaimByType (state:UserState):any {
    return (claimType:string) => {
      if (!state.userIdentity || !state.userIdentity.Claims) {
        return []
      } else {
        return flatMap(filter(state.userIdentity.Claims, { Type: claimType }), 'Value')
      }
    }
  },
  getCountryPermissions (state:UserState):number[] {
    if (!state.userIdentity || !state.userIdentity.Claims) {
      return []
    } else {
      var countryPermissions = flatMap(filter(state.userIdentity.Claims, { Type: 'Country_Permission' }), 'Value')
      if (countryPermissions[0] === 'All') {
        return []
      } else {
        return map(countryPermissions, (value) => { return parseInt(value) })
      }
    }
  },
  getCustomerPermissions (state:UserState):number[] {
    if (!state.userIdentity || !state.userIdentity.Claims) {
      return []
    } else {
      var customerPermissions = flatMap(filter(state.userIdentity.Claims, { Type: 'Customer_Permission' }), 'Value')
      if (customerPermissions[0] === 'All') {
        return []
      } else {
        return map(customerPermissions, (value) => { return parseInt(value) })
      }
    }
  },
  firstName (state:UserState):string {
    if (!state.userIdentity || !state.userIdentity.Name) {
      return ''
    } else {
      return state.userIdentity.Name.split(' ')[0]
    }
  },
  userName (state:UserState):string {
    if (!state.userIdentity || !state.userIdentity.Name) {
      return ''
    } else {
      return state.userIdentity.Name
    }
  }
}
export default ({
  namespaced: true,
  state: new UserState(),
  mutations,
  actions,
  getters
})
